import React from "react";
import { Link } from "react-router-dom";

const EventPoster = () => {
  const styles = {
    container: {
      textAlign: "center",
      padding: "3rem 1rem",
      backgroundColor: "#f9fafb",
      minHeight: "100vh",
    },
    posterWrapper: {
      maxWidth: "800px",
      margin: "2rem auto",
    },
    poster: {
      width: "100%",
      maxHeight: "70vh",
      objectFit: "contain",
      borderRadius: "30px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    },
    links: {
      marginTop: "2rem",
    },
    link: {
      margin: "0 1rem",
      fontWeight: "bold",
      color: "#2563eb",
      textDecoration: "none",
    },
    maintenance: {
      marginTop: "3rem",
      fontSize: "0.9rem",
      color: "#6b7280",
    },
  };

  return (
    <div style={styles.container}>
      <h1> DolaGi</h1>
	  <h2>Virtual Monthly Challenge</h2>
	  {/*<h2>Biru Hor, Sajot Kena</h2>*/}

      <div style={styles.posterWrapper}>
        <img
          src="/poster.png"
          alt="Event Poster"
          style={styles.poster}
        />
      </div>

      <div style={styles.links}>
        <Link to="/leaderboard" style={styles.link}>Leaderboard</Link>
	  {/*<Link to="/register" style={styles.link}>Register</Link>*/}
	  {/* <Link to="/info" style={styles.link}>Info</Link>*/}
      </div>
    </div>
  );
};

export default EventPoster;

